
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPaths, GetStaticProps, NextPage } from 'next/types';
import { Products } from '@components/products';
import { ALU } from '@consts/ALU';
import { IProduct } from '@type/products';
import { getAllAluByParent, getAllAluPathsById, getAluById, } from '@utils/getProducts';
import { NextSeo } from 'next-seo';
import { PvcWindowContent } from '@components/PvcWindowContent';
interface IProductCard {
    product: IProduct;
    products: IProduct[];
}
const AluprofPage: NextPage<IProductCard> = ({ product, products }) => {
    return (<>
      <NextSeo title={product?.title}/>
      <div className="max-w-7xl mx-auto py-2 px-4 sm:px-6 lg:px-8">
        <PvcWindowContent product={product}/>
        {products && <Products products={products} showId productPage/>}
      </div>
    </>);
};
export const getStaticPaths: GetStaticPaths = async () => {
    const PATHS_IDS = Object.values(ALU.SLIDING_DOORS.ALUPROF);
    const { paths: path } = await getAllAluPathsById(PATHS_IDS);
    const paths = path.map((p: {
        slug: any;
        databaseId: any;
        language: {
            code: string;
        };
    }) => ({
        params: {
            slug: `${p.slug}-${p.databaseId}`,
        },
        locale: p.language.code.toLowerCase(),
    }));
    return {
        paths,
        fallback: 'blocking',
    };
};
const getStaticProps: GetStaticProps = async (context) => {
    const slug = context.params?.slug as string;
    const locale = (context.locale as string) || ('PL' as string);
    const LOCALE = locale === 'cz' ? 'CS' : locale.toUpperCase();
    const PRODUCT_ID = slug?.split('-').pop();
    const { product } = await getAluById(PRODUCT_ID, LOCALE);
    const { products } = await getAllAluByParent(ALU.SLIDING_DOORS.ALUPROF[LOCALE as keyof typeof ALU.SLIDING_DOORS.ALUPROF], LOCALE);
    return {
        props: {
            product,
            products,
        },
    };
};
export default AluprofPage;

    async function __Next_Translate__getStaticProps__196386c4f11__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/alu/sliding-doors/aluprof/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196386c4f11__ as getStaticProps }
  